// Traducciones comunes en inglés
const common = {
  chapters: "CHAPTERS",
  chapter: "Chapter",
  form: "YOUR OPINION MATTERS!",
  selectChapter: "Select a Chapter",
  backToMenu: "Back to Main Menu",
  backtoChapters: "Back to chapters",
  chapterOptions: "Chapter Options",
  comic: "Comic",
  articles: "Cards",
  extras: "Extras",
  pause: "Pause",
  suscribe: "Subscribe to be the first to see it!",
  privacyPolicy: "Privacy Policy",
  notFoundTitle: "404 - Page Not Found",
  notFoundMessage: "We're sorry, the page you're looking for doesn't exist.",
  backToHome: "Back to Home",
  callToAction: {
    title: "What did you think of this chapter?",
    subtitle: "Your opinion helps us create better stories. Share your experience with us.",
    primaryButton: "Rate Chapter!",
    primaryButtonHover: "Give us your opinion!",
    footer: "Every opinion counts to improve Zaquiel's adventure",
    endIndicator: "End of chapter"
  }
}; 

export default common; 